import { render, staticRenderFns } from "./ReservationStatusByGroup.vue?vue&type=template&id=61502b06&scoped=true&"
import script from "./ReservationStatusByGroup.vue?vue&type=script&lang=js&"
export * from "./ReservationStatusByGroup.vue?vue&type=script&lang=js&"
import style0 from "./ReservationStatusByGroup.vue?vue&type=style&index=0&id=61502b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61502b06",
  null
  
)

export default component.exports